import { getI18n } from 'react-i18next';
import { call, fork, put, take } from 'redux-saga/effects';
import { onEnqueueErrorSnackbar } from './enqueueSnackbarFlow';
import {Api} from '../api';
import { ApartmentAssets } from '../api/types';
import Logger from '../common/logger';
import IssueReportEvents from '../action/issueReportsEvents';
import IssueReportsCommands from '../action/issueReportsCommands';

export const onFetchAssetForIssueReport = function* () {
    try {
        const assets: ApartmentAssets[] = yield call(Api.fetchAssetsForIssueReport);
        yield put(IssueReportEvents.assetsFetched({ assets }));
    } catch (error) {
        Logger('Saga').error(error);
        yield fork(onEnqueueErrorSnackbar, getI18n().t('assetGroups.error.fetch_assetGroups'));
    }
};


export function* fetchAssetForIssueReportsFlow() {
    while (true) {
        yield take(IssueReportsCommands.fetchAssetsForIssueReports.toString());
        yield fork(onFetchAssetForIssueReport);
    }
}
